import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import helper from '../../../../helper';

export default {
	faqGroups({
        commit
    }, ) {
        axios.get(process.env.MIX_API_URL + 'cms/faq-setting/active-faq-group')
            .then(response => new ResponseDataExtractor(response).data)
            .then(data => commit('SET_FAQS_CONTENT', data))
            .catch(() => console.log('Error when get faq data from api'));
    },
}